module.exports = __webpack_public_path__ + "img/kaide_minhang.ed9e663e.png";